import { render, staticRenderFns } from "./SimpleHelperMsg.vue?vue&type=template&id=6f236560"
import script from "./SimpleHelperMsg.vue?vue&type=script&lang=js"
export * from "./SimpleHelperMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports